export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PasswordReset.vue?vue&type=template&id=27d06c28"


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/resetpass/PasswordReset.vue?vue&type=template&id=27d06c28
// module id = wnSH
// module chunks = 41